<template>
  <div>
    <!-- footer START here -->
    <footer>
      <!-- container START here -->
      <div class="container">
        <div id="footer-colums">
          <!-- footer-colum1 START here -->
          <div class="footer-colum">
            <h4>Company</h4>
            <ul>
              <li>
                <router-link :to="{ path: '/faq' }">
                  FAQ
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/contact' }">
                  Contact Us
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/disclaimer' }">
                  Disclaimer
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/privacy' }">
                  Privacy Policy
                </router-link>
              </li>
              <li>
                <router-link :to="{ path: '/terms' }">
                  Terms of Use
                </router-link>
              </li>
            </ul>
          </div>
          <!-- footer-colum1 END here -->
          <!-- footer-colum2 START here -->
          <div class="footer-colum">
            <h4>Get Social with Us</h4>
            <ul>
              <li>
                <a href="http://twitter.com/#!/StumpTheSpread" target="_blank">Twitter</a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCUPBXcfLwRpmtGlDqmYmiXQ"
                  target="_blank"
                >Youtube</a>
              </li>
            </ul>
          </div>
          <!-- footer-colum2 END here -->
          <!-- footer-colum3 START here -->
          <div class="footer-colum">
            <h4>Contact Methods</h4>
            <ul>
              <li>
                <!-- href="https://stumpthespread.com/maillst/?p=subscribe&id=1" -->
                <!-- target="_blank" -->
                <a
                  href="https://stumpthespread.com/register"
                >Mailing List</a>
              </li>
              <li>
                <router-link :to="{ path: '/contact' }">
                  Email
                </router-link>
              </li>
              <li>
                <a href="mailto:support@stumpthespread.com">support@stumpthespread.com</a>
              </li>
            </ul>
          </div>
          <!-- footer-colum3 END here -->
          <!-- footer-colum4 START here -->
          <div class="footer-colum no-margin">
            <h4>From The Blog</h4>
            <ul>
              <li v-for="post in posts" :key="post.id">
                <router-link :to="{ path: '/blog' }">
                  {{ post }}
                </router-link>
              </li>
            </ul>
          </div>
          <!-- footer-colum4 END here -->
        </div>
      </div>
      <!-- container END here -->
      <!-- bottom-footer START here -->
      <div id="bottom-footer">
        <!-- container START here -->
        <div class="container">
          <p class="alignleft">
            &copy; Copyright 2009-{{ year }} StumptheSpread.com. All rights
            reserved.
          </p>
          <ul id="social-list" class="alignright">
            <li>
              <a
                href="https://stumpthespread.com/maillst/?p=subscribe&id=1"
                target="_blank"
                rel="tipsy"
                title="Monthly Newsletter"
              ><div class="sprite email" /></a>
            </li>
            <li>
              <a
                href="http://twitter.com/#!/StumpTheSpread"
                target="_blank"
                rel="tipsy"
                title="Twitter"
              >
                <div class="sprite twitter" />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/channel/UCUPBXcfLwRpmtGlDqmYmiXQ"
                target="_blank"
                rel="tipsy"
                title="Youtube"
              ><div class="sprite youtube" /></a>
            </li>
          </ul>
        </div>
        <!-- container END here -->
      </div>
      <!-- bottom-footer END here -->
    </footer>
    <!-- footer END here -->
    <login />
  </div>
</template>

<script>
import Login from "../components/login";
import PostRepository from "../data/post.repository.js";
export default {
  name: "StsFooter",
  components: {
    login: Login,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      posts: [],
    };
  },
  mounted() {
    PostRepository.recent().then((res) => {
      this.posts = res;
    });
  },
};
</script>

<style lang="css" scoped>
footer {
  min-width: 960px;
}
</style>



// WEBPACK FOOTER //
// StsFooter.vue?52ae8a6c